module.exports = __webpack_public_path__ + "img/Caves.b4431e4e.svg";